import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup } from '@angular/forms';


import { ExcelExportService } from '../../../../services/excel-export.service';
import { MatTableDataSource } from '@angular/material/table';
import { UserService } from '../../../../services/user';
import { ItemsService } from '../../../../services/items.service';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { ClientsService } from '../../../../services/clients.service';
import { SuppliesService } from '../../../../services/supplies';
import { FinancialManagerService } from '../../../../services/financial-manager';
import { TranslocoService } from '@ngneat/transloco';

type StatementType = 'order' | 'supply' | 'opening_balance' | 'manual_adjustment';

interface StatementRow {
  type: StatementType;
  id: number;
  ref_id?: number | null;
  amount: number;
  paid: number | null;
  remaining: number | null;
  balance: number;
  date: string | Date;
}

@Component({
  selector: 'app-accountstatement',
  templateUrl: './accountstatement.component.html',
  styleUrl: './accountstatement.component.scss'
})
export class AccountstatementComponent implements OnInit {

  @Input() isProfile: string = "";

  allData: any[] = [];
  showadd: boolean = false;

  displayedColumns: string[] = [
    'type',
    'id',
    'details',
    'balance'
  ];

  summary: any = null;
  client: any = null;
  opening_balance: number = 0;
  opening_balance_type: number | null = null;

  contentReady: boolean = true;
  noData: boolean = false;
  showPopUp: boolean = false;
  showRejectPopUp: boolean = false;
  orderchange!: FormGroup;
  reason: string = "";
  orderId!: any;
  statuslist: any;
  clear: boolean = false;
  accountType!: string;
  isAdmin!: boolean;
  isSubAdmin!: boolean;
  stockTotal!: any;
  totalItems!: any;
  searched: boolean = false;
  showoptions: boolean = false;
  searchKey: string = '';
  isAr: boolean = localStorage.getItem("language") == "ar";
  dataSource: MatTableDataSource<any>;
  warehouseId!: any;
  allWareHouses: any;
  phoneNumber: any;

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  warehouseIsStore: boolean = false;

  // Popup form data
  amount: number | null = null;
  direction: '1' | '2' | null = null;

  userId!: any;
  clientname!: any;

  constructor(
    private router: Router,
    private _clientsService: ClientsService,
    private _FinancialManager: FinancialManagerService,
    private _suppliesService: SuppliesService,
    private excelExportService: ExcelExportService,
    private _orders: ItemsService,
    private _userService: UserService,
    private route: ActivatedRoute,
    private transloco: TranslocoService // ✅ Inject TranslocoService
  ) {
    this.dataSource = new MatTableDataSource(this.allData);
  }

  ngOnInit(): void {
    this._userService.getAccountType().subscribe({
      next: (data) => {
        this.accountType = data['user_type'];
        this.isAdmin = this.accountType == "1" || this.accountType == "10";
        this.isSubAdmin = this.accountType == "6";
      },
      error: (error) => console.error(error),
    });

    this.route.queryParams.subscribe(params => {
      if (params["phone"]) {
        this.phoneNumber = params["phone"];
        this.getStatementByPhone(params["phone"]);
      }
    });
  }

  // ================================
  // ✅ Helper Methods for Table Display
  // ================================

  /** Returns translated label for transaction type */
  getTypeLabel(type: StatementType): string {
    const labels: Record<StatementType, string> = {
      'order': this.transloco.translate('Order'),
      'supply': this.transloco.translate('supply'),
      'opening_balance': this.transloco.translate('opening_balance'),
      'manual_adjustment': this.transloco.translate('manual_adjustment')
    };
    return labels[type] || type;
  }

  /** Returns CSS class for type badge styling */
  getTypeClass(type: StatementType): string {
    return type; // Returns: 'order', 'supply', 'opening_balance', or 'manual_adjustment'
  }

  // ================================
  // ✅ Popup Modal Methods
  // ================================

  /** Close the adjust balance popup and reset form */
  close(): void {
    this.showadd = false;
    this.amount = null;
    this.direction = null;
  }

  /** Handle popup form submission */
  onSubmit(): void {
    if (!this.amount || this.amount <= 0 || !this.direction) {
      // Optional: Show validation message
      return;
    }

    // Call existing method to process the adjustment
    this.updateOpeningBalance();
  }

  /** Open the adjust balance popup */
  openAdjustBalanceDialog(): void {
    this.showadd = true;
    // Reset form when opening
    this.amount = null;
    this.direction = '1';
  }

  // ================================
  // ✅ Existing Business Logic (Updated)
  // ================================

  updateOpeningBalance(): void {
    if (!this.amount || !this.direction || !this.phoneNumber) {
      return;
    }

    let signedAmount = Number(this.amount);

    // Apply direction: '2' = debit (negative), '1' = credit (positive)
    if (this.direction === '2') {
      signedAmount = -Math.abs(signedAmount);
    } else {
      signedAmount = Math.abs(signedAmount);
      // Add revenue record for credit adjustments
      this.addRev(signedAmount);
    }

    this._suppliesService.createManualAdjustment(
      this.phoneNumber,
      signedAmount,
      localStorage.getItem("posId")
    ).subscribe({
      next: (res) => {
        // Refresh statement data after successful adjustment
        this.getStatementByPhone(this.phoneNumber);
        // Close popup and reset form
        this.close();
      },
      error: (err) => {
        console.error('Adjustment error:', err);
        // Optional: Show error message to user
      }
    });
  }

  details(orderId: number, type: StatementType): void {
    if (type === 'supply') {
      this.router.navigate(['/supplieinvoice'], { queryParams: { id: orderId } });
    } else {
      this.router.navigate(['/warehouseinvoice'], { queryParams: { id: orderId } });
    }
  }

  addRev(total: number, type?: any): void {
    this.contentReady = true;

    const bonusPayload = {
      warehouse_id: localStorage.getItem("posId"),
      employee_id: this.userId,
      username: localStorage.getItem("username"),
      amount: total,
      amount_type: "0",
      note: `نحصيل عميل - ${this.phoneNumber} ${this.client?.client_name || ''}`,
      type: "3",
    };

    this._FinancialManager.addRevenue(bonusPayload).subscribe({
      next: (data) => {
        this.contentReady = false;
      },
      error: (error) => {
        console.error('Revenue error:', error);
        this.contentReady = false;
      },
    });
  }

  getStatementByPhone(phone: string): void {
    this.contentReady = true;

    this._suppliesService.getStatementByPhone(phone).subscribe({
      next: (res: any) => {
        this.client = res.client;

        // Map API response to StatementRow interface
        const rows: StatementRow[] = (res.statement || []).map((row: any) => {
          const amount = Number(row.amount ?? 0);
          const paid = row.paid != null ? Number(row.paid) : null;

          return {
            type: row.entry_type as StatementType,
            id: row.ref_id ?? row.id,
            ref_id: row.ref_id,
            amount: amount,
            paid: paid,
            remaining: paid !== null ? amount - paid : null,
            balance: Number(row.balance ?? 0),
            date: row.entry_date,
          };
        });

        this.dataSource = new MatTableDataSource<StatementRow>(rows);
        this.noData = rows.length === 0;

        // Calculate summary balances
        const balance = Number(res.balance ?? 0);
        this.summary = {
          company_owes: balance > 0 ? balance : 0,      // Customer owes company (positive balance)
          customer_owes: balance < 0 ? Math.abs(balance) : 0,  // Company owes customer (negative balance)
          net_balance: balance,
        };

        this.contentReady = false;
      },
      error: (err) => {
        console.error('Statement error:', err);
        this.dataSource = new MatTableDataSource<StatementRow>([]);
        this.noData = true;
        this.summary = null;
        this.contentReady = false;
      },
    });
  }

  exportToExcel(): void {
    this.excelExportService.exportToExcel('orderstable', 'AccountStatement', []);
  }

  getAllClients(perpage: any, page: any, warehouse_id: any): void {
    this.contentReady = true;
    this.searched = false;

    this._clientsService.getClients(perpage, page, warehouse_id).subscribe({
      next: (data) => {
        this.allData = data['data'];
        this.stockTotal = data['total'];
        this.totalItems = data['last_page'];

        this.dataSource = new MatTableDataSource(this.allData);
        this.contentReady = false;
        this.noData = this.allData.length === 0;
      },
      error: (error) => {
        console.error('Clients error:', error);
        this.contentReady = false;
      },
    });
  }
}
